import moment from "moment";

export const parseTrades = (
  msg,
  lastParsedPrice,
  lastParsedSymbol,
  lastParsedDate,
  lastParsedTime,
) => {
  const values = [];
  let buff = "";
  for (const ch of msg) {
    if ("&=@|:!".includes(ch)) {
      values.push(buff, ch);
      buff = "";
    } else {
      buff += ch;
    }
  }

  const ticks = [];
  let tick = {};

  const processTick = () => {
    if (tick.prices === undefined || tick.prices.length === 0) {
      tick.C = lastParsedPrice;
    } else {
      [tick.O, tick.L, tick.H, tick.C] = tick.prices;
    }
    lastParsedPrice = tick.C;
    tick.S = tick.S || lastParsedSymbol;
    tick.Date = tick.Date || lastParsedDate;
    tick.Time = tick.Time || lastParsedTime;
    tick.DT = moment.utc(`${tick.Date}${tick.Time}`, "YYMMDDhhmm").toDate();
    ticks.push(tick);

    lastParsedDate = tick.Date;
    lastParsedTime = tick.Time;
    lastParsedPrice = tick.C;
    lastParsedSymbol = tick.S;
    tick = {};
  };

  values.forEach((value, idx) => {
    switch (value) {
      case "&":
        tick.TY = "H";
        break;
      case "=":
        tick.S = values[idx - 1];
        break;
      case "@":
        tick.Date = values[idx - 1];
        break;
      case "|":
        tick.Time = values[idx - 1];
        break;
      case ":":
        tick.prices = tick.prices || [];
        tick.prices.push(parseFloat(values[idx - 1]));
        break;
      case "!":
        tick.Q = parseInt(values[idx - 1]);
        processTick();
        break;
      default:
    }
  });

  return ticks;
};

export const roundValue2 = (num) =>
  Math.round((num + Number.EPSILON) * 100) / 100;

export const endsWith = (str, suffix) =>
  str.indexOf(suffix, str.length - suffix.length) !== -1;
